export default __webpack_public_path__ + "static/media/auteuilmini.9ccd9f60.jpg";